import { render, staticRenderFns } from "./addRuleHPf.vue?vue&type=template&id=38be3584&scoped=true&"
import script from "./addRuleHPf.vue?vue&type=script&lang=js&"
export * from "./addRuleHPf.vue?vue&type=script&lang=js&"
import style0 from "./addRuleHPf.vue?vue&type=style&index=0&id=38be3584&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be3584",
  null
  
)

export default component.exports